<template>
  <v-sheet v-if="list != null" elevation="1" style="
                    position: absolute;
                    right: 16px;
                    bottom: 16px;
                    z-index: 170;
                    overflow: hidden;
                  " class="rounded-lg">
    <template v-if="colortip">
      <div v-if="useItemColor && itemType == 'Object'">
        <div v-for="listItem in itemList" :key="listItem.Id" class="white--text px-2 py-1"
          :style="'background-color: ' + statuscolor(listItem.Id) + ';'">
          <v-icon v-text="statusicon(listItem.Id)" size="15" color="white" class="mr-1 mb-1">
          </v-icon>
          {{ listItem.Name }}
        </div>
      </div>
      <div v-if="!useItemColor && itemType == 'Object'">
        <div v-for="listItem in itemList" :key="listItem.Id" class="px-2 py-1">
          <v-icon v-text="statusicon(listItem.Id)" size="15" color="white" class="mr-1 mb-1">
          </v-icon>
          {{ listItem.Name }}
        </div>
      </div>
      <div v-if="itemType == 'String'" style="max-height: 500px; overflow: scroll;">
        <div v-for="listItem in itemList" :key="listItem">
          <div style="margin: 2px 10px;">{{  listItem }}</div>
          </div>
      </div>
    </template>
    <div class="d-flex justify-end">
      <div v-if="!colortip" class="d-flex align-stretch flex-column" style="
                    position: absolute;
                    width: 100%;
                    height: 100%;">
      </div>
      <v-btn icon @click="colortip = !colortip">
        <v-icon :color="colortip ? '' : 'white'" :style="getBackgroundStyle(colortip)">mdi-help-box</v-icon>
      </v-btn>
    </div>
  </v-sheet>
</template>


<script>


const today = new Date();
today.setDate(today.getDate() - 4);
export default {
  name: "PlanningColorHelper",
  props: {
    list: {
      type: Array,
      required: true
    },
    useItemColor: {
      type: Boolean,
      default: true
    },
    itemType: {
      type: String,
      default: "Object"
    }
  },
  components: {},
  mixins: [],

  data() {
    return {
      colortip: false,
    };
  },

  mounted() { },

  methods: {
    getBackgroundStyle(colortip) {
      return !colortip ? "background-image: linear-gradient(180deg, red,orange,yellow,green,blue,indigo,violet); height: 36px; width: 36px" : 'background-color: white';
    }
  },

  computed: {
    itemList() {
      return this.list;
      //return this.$store.getters["BackgroundUpdater/Value"]("StatusMap");
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>